<!--
	分页参数                描述                                   默认值
	total                 总条目数                                   0
	page-size             每页显示条目个数                           20
	page-count            总页数                                 Math.ceil
	current-page          当前页数                                  1
	page-sizes           每页显示个数选择器的选项设置              [20,50,100]

	//event
	size-change      pageSize 改变时会触发              回调参数： 每页条数size
	current-change   currentPage 改变时会触发           回调参数： 当前页currentPage
		- 上一页
		- 下一页
		- 首页
		- 末页
	@size-change="handleSizeChange"
	@current-change="handleCurrentChange"
 -->

<template>
	<div class="pagination cSub vaM_E" :class="{ disable: pagination.total == 0 }">
		<!-- <span>{{$t('word20',['每页数量'])+":"}}</span> -->

		<div class="group cb w3x-min_E bdSub_E tra-fast_E sizeS_E" v-if="styleType == 'max'">
			<button
				class="fa fa-angle-left pl05x pr05x"
				:title="$t('cmd2', ['上一页'])"
				:class="{ disable: pagination.request.page === 1 && totalPages !== 0 }"
				@click="goPage(pagination.request.page - 1)"
			></button>
		</div>
		<div class="group cb w3x-min_E bdSub_E tra-fast_E sizeS_E" v-if="styleType == 'max'">
			<button class="fa" :class="{ active: pagination.request.page == 1 }" v-if="totalPages !== 0" @click="goPage(1)">1</button>
			<span v-if="pagination.request.page > 4 && showType" class="cSub pt1x taC">...</span>
			<span v-if="pagination.request.page > 3 && !showType" class="cSub pt1x taC">...</span>
			<template v-for="(page, index) in totalPages">
				<button
					@click="goPage(page)"
					:key="index"
					v-if="index >= pagination.request.page - 3 && index < pagination.request.page + 2 && showType && index !== totalPages - 1 && index !== 0"
					class="pl05x pr05x"
					:class="{ active: index + 1 === pagination.request.page }"
				>
					{{ page }}
				</button>
			</template>
			<template v-for="(page, index) in totalPages">
				<button
					@click="goPage(page)"
					:key="index"
					v-if="index >= pagination.request.page - 2 && index < pagination.request.page + 1 && !showType && index !== totalPages - 1 && index !== 0"
					class="pl05x pr05x"
					:class="{ active: index + 1 === pagination.request.page }"
				>
					{{ page }}
				</button>
			</template>
			<span v-if="totalPages - pagination.request.page > 3 && showType" class="cSub pt1x taC">...</span>
			<span v-if="totalPages - pagination.request.page > 2 && !showType" class="cSub pt1x taC">...</span>
			<button class="fa" v-if="totalPages !== 1" :class="{ active: pagination.request.page == totalPages }" @click="goPage(totalPages)">
				{{ totalPages }}
			</button>
		</div>

		<div class="group cb w3x-min_E bdSub_E tra-fast_E sizeS_E" v-if="styleType == 'max'">
			<button
				class="fa fa-angle-right pl05x pr05x"
				:title="$t('cmd3', ['下一页'])"
				:class="{ disable: totalPages === pagination.request.page }"
				@click="goPage(pagination.request.page + 1)"
			></button>
		</div>
		<Select :list="pageSize" :dir="'up'" :bindActive="pagination.request.size" :size="'s'" @Click="sizeChange"></Select>
		<span v-show="showType">
			<span class="ml1x">{{ $t("all53", ["跳至"]) }}</span>
			<span v-if="styleType == 'max'">
				<InputText class="w7x dpIB taC" name="inputPage" v-model="inputPage" :only="'absInt'" :fn="goPage" :clearBtn="false" :size="'s'"></InputText>
				<!-- / <span class="cMain b">{{totalPages}}</span> -->
				<!--
				<input type="text" class="bdSub w6x tra-fast" v-model="inputPage"
						v-number-only
						@keypress.enter="goPage(inputPage)"> / <span class="b">{{totalPages}}</span>
				-->
				<span>{{ $t("word18", ["页"]) }}</span>
				<!-- <span class="cMain b">{{pagination.total}}</span> -->
				<span class="cMain b pr2x">{{ $t("all64", [pagination.total, "共{0}条"]) }}</span>
			</span>
		</span>
	</div>
</template>
<script>
let defPagination = {
	request: {
		page: 1,
		size: 50,
	},
	total: 0,
	// totalPages: 0
};
export default {
	name: "Pagination",
	components: {},
	props: {
		styleType: {
			type: String,
			default: "max",
		},
		pagination: {
			type: Object,
			default: (function () {
				return $.extend(true, {}, defPagination);
			})(),
		},
		getList: {
			type: Function,
			default: function () {},
		},
		pageSize: {
			type: Array,
			default: () => [
				{ text: `50${getLanguageStr("all52", "条/页")}`, value: 50 },
				{ text: `100${getLanguageStr("all52", "条/页")}`, value: 100 },
				{ text: `200${getLanguageStr("all52", "条/页")}`, value: 200 },
				{ text: `500${getLanguageStr("all52", "条/页")}`, value: 500 },
			],
		},
		showType: {
			type: Boolean,
			default: true, // 大场景为 true 小场景为 false
		},
	},
	data() {
		return {
			inputPage: defPagination.request.page,
			totalPages: 0,
		};
	},
	watch: {
		// pagination:{
		// 	deep:true,
		// 	handler:function(){
		// 		// this.getTotalPages();
		// 	}
		// },
		"pagination.request.page"(val) {
			this.inputPage = val;
		},
		"pagination.total": function (val, oldV) {
			this.getTotalPages(val, oldV);
		},
	},
	directives: {
		numberOnly: {
			bind: function (el) {
				el.handler = function () {
					el.value = el.value.replace(/\D+/, "");
				};
				el.addEventListener("input", el.handler);
			},
			unbind: function (el) {
				el.removeEventListener("input", el.handler);
			},
		},
	},
	methods: {
		getTotalPages: function (val, oldV) {
			this.totalPages = Math.ceil(this.pagination.total / this.pagination.request.size) || 0;
			let maxPage = Math.ceil(val / this.pagination.request.size);
			if (maxPage < this.inputPage && maxPage > 0) {
				this.inputPage = maxPage;
				this.goPage(this.inputPage);
			}
		},
		sizeChange: function (index) {
			this.pagination.request.page = 1;
			this.pagination.request.size = this.pageSize[index].value;
			this.getTotalPages();
			this.getList();
		},
		goPage(page) {
			page = Number(page);
			if (page > this.totalPages) page = this.totalPages;
			else if (page < 1) page = 1;
			this.pagination.request.page = this.inputPage = page;

			this.$nextTick(() => {
				this.$set(this, "inputPage", page);
			});
			// this.$emit('current-change', page)
			this.getList();
		},
	},
	// computed:{
	// },
	created() {
		$.extend(true, this.pagination, defPagination);
		this.pagination.request.size = this.pageSize[0].value;
		this.inputPage = this.pagination.request.page;
	},
	mounted() {
		// this.$watch("pagination.total",function(){
		//   trace(this.pagination.total,true)
		// });
		// this.$nextTick(function(){
		// 	trace(this.pagination)
		// });
		// this.pagination=$.extend(this.pagination,defPagination);
		// this.pagination={...this.pagination,...defPagination};
		// this.$set(this,"inputPage",this.pagination.page);
	},
};
</script>
<style lang="scss" scoped>
.pagination {
	display: inline-block;
	float: right;
	border: none;
	> * {
		vertical-align: middle;
	}
	// >div+*{margin:{left:1em;};}
	.group {
		display: inline-block;
		> :first-child {
			border: none;
			border-radius: $radiusLight;
		}
		> :last-child {
			border: none;
			border-radius: $radiusLight;
		}
		> :first-child:last-child {
			border: none;
			border-radius: $radiusLight;
		}
		> * {
			display: block;
			float: left;
			line-height: 1;
			border: none;
		}
		> button + button {
			border: none;
		}
		> [active],
		> .active,
		> button:hover {
			color: #fff;
			background-color: $mainColor;
			border-color: $mainColor;
			border-radius: $radiusLight;
		}
		> span {
			background-color: transparent !important;
			border: none;
		}
	}
}
//tr .flipPage{padding:{top:0;bottom:0;};}
</style>



// WEBPACK FOOTER //
// src/components/common/ui/Pagination.vue